import styled from "styled-components";

export const Container = styled.footer`
    text-align: center;
    border-top: 2px solid var(--bg-secondary);
    padding: 20px 0;
    font-size: 0.7rem;
    >span{
        color: var(--green-color);
    }
`